import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  full: {
    display: 'block',
    width: 144,
    height: 18,
  },
  compact: {
    display: 'block',
    width: 36,
    height: 36,
  },
});

type EnlivioLogoProps = {
  compact: boolean;
};

const EnlivioLogo = ({ compact }: EnlivioLogoProps) => {
  const classes = useStyles();

  return (
    <img
      className={compact ? classes.compact : classes.full}
      src={
        compact ? '/enlivio-health-mark.png' : '/enlivio-health-footer-logo.svg'
      }
      alt=""
      aria-hidden="true"
    />
  );
};

export default EnlivioLogo;
